import ManagementsAgent from "../../components/ManagementsAgent/ManagementsAgent";


export default function ManagementsAgentPage() {
  return <ManagementsAgent />;
}